"use client";

import { TabsList, TabsRoot, TabsTab } from "@/components/ui/Tabs";
import { useRouter, usePathname } from "next/navigation";
import { useCallback } from "react";
import styles from "./SearchPage.module.css";
import { Translate } from "@/components/Translate";
import { getActiveTab, type SearchTab, type SearchTabCounts } from "../utils/searchTabs";
import { withSearchParams } from "@/components/withSearchParams";

interface SearchTabsProps {
	counts?: SearchTabCounts;
}

export const SearchTabs = withSearchParams<SearchTabsProps>(({ counts, searchParams }) => {
	const router = useRouter();
	const pathname = usePathname();

	const requestedTab = searchParams.get("tab") as SearchTab | null;

	const currentTab = requestedTab || getActiveTab(null, counts);

	const handleTabChange = useCallback(
		(value: SearchTab) => {
			const newParams = new URLSearchParams(searchParams.toString());
			newParams.set("tab", value);
			const newUrl = `${pathname}?${newParams.toString()}`;
			router.replace(newUrl, { scroll: false });
		},
		[router, searchParams, pathname],
	);

	return (
		<TabsRoot value={currentTab} onValueChange={handleTabChange}>
			<div className={styles.tabsContainer}>
				<TabsList className={styles.tabsList}>
					<TabsTab value="products" className={styles.tabsTrigger}>
						<Translate>Products</Translate>
						{counts?.products !== undefined && (
							<span className={styles.tabCount}>({counts.products})</span>
						)}
					</TabsTab>
					<TabsTab value="articles" className={styles.tabsTrigger}>
						<Translate>Articles</Translate>
						{counts?.articles !== undefined && (
							<span className={styles.tabCount}>({counts.articles})</span>
						)}
					</TabsTab>
					<TabsTab value="pages" className={styles.tabsTrigger}>
						<Translate>Pages</Translate>
						{counts?.pages !== undefined && (
							<span className={styles.tabCount}>({counts.pages})</span>
						)}
					</TabsTab>
					<TabsTab value="categories" className={styles.tabsTrigger}>
						<Translate>Categories</Translate>
						{counts?.categories !== undefined && (
							<span className={styles.tabCount}>({counts.categories})</span>
						)}
					</TabsTab>
				</TabsList>
			</div>
		</TabsRoot>
	);
});
